// export default BulkPublic;
import React, { useState, useEffect, useMemo } from "react";
import {
  TextField,
  Typography,
  MenuItem,
  Grid,
  Modal,
  Button,
} from "@mui/material";
import data from "./dropDown";
import { API } from "../pages/backend";
import { useDispatch, useSelector } from "react-redux";
import { setTransactionDetails } from "../store/reducers/transactionDetails";
import InputField from "./forms/input/TextInput/InputField";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { examPrices } from "../partials/examboardprices/examprices";
import FormButton from "./ui/button/FormButton";
import axios from "axios";
import { closeModal } from "../store/reducers/modal";
import Spinner from "./ui/Spinner";
import InvoiceButtonWithConfirmation from "./InvoiceButtonWithConfirmation";

const BulkPublic = ({
  dat,
  examName,
  examType = "PUBLIC SERVICE EXAMINATION",
  lateRegistrationType = "Model/Screening College Late Registration",
  payerID,
}) => {
  const { LgaForPublic } = data;

  const token = useSelector((state) => state.user.data.token);
  // const details = useSelector((state) => state.transactionDetails);
  const user = useSelector((state) => state.user.data.details);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [publicBulkData, setPublicBulkData] = useState([]);

  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [candidates, setCandidates] = useState([
    { lastName: "", middleName: "", firstName: "", lga: "" },
  ]);

  console.log(candidates.length);
  const candidateInfo = candidates.map((candidate, index) => ({
    surname: candidate.lastName,
    middleName: candidate.middleName,
    firstName: candidate.firstName,
    //  lgaIdNumber: candidate.lga,
    locationIdOrExamId: candidate.lga,
  }));

  // console.log(candidateInfo)

  const addCandidate = () => {
    const newCandidate = {
      lastName: "",
      middleName: "",
      firstName: "",
      lga: "",
    };
    setCandidates([...candidates, newCandidate]);
  };

  const removeCandidate = (index) => {
    const updateCandidate = candidates.filter((_, idx) => idx !== index);
    setCandidates(updateCandidate);
  };

  const handleCandidateChange = (index, field, value) => {
    const updatedCandidates = [...candidates];
    updatedCandidates[index] = { ...updatedCandidates[index], [field]: value };
    setCandidates(updatedCandidates);
  };

  const priceInt = examPrices.publicServiceExamCompulsory.replace(/\D/g, "");
  const totalFee = priceInt * candidates.length;

  // const totalAmount = parseInt(charge) + parseInt(totalFee);

  const charge = useMemo(() => {
    let ch = 0.01 * totalFee;
    if (ch > 3000) return 3000;
    return ch;
  }, [totalFee]);

  const totalAmount = parseInt(charge) + parseInt(totalFee);

  // console.log(user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
    } catch (error) {}
  };

  const getPublicExam = async () => {
    const examBillable_url = `${API}/cbs/public_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setPublicBulkData(res?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const generateBillNo = async () => {
    // Start the timeout
    let timeoutId = setTimeout(() => {
      setShowTimeoutModal(true);
    }, 120000); // 2 minutes in milliseconds

    const body = {
      payer_id: payerID,
      customer_name: `${user.lastName} ${user.firstName}`,
      selected_quantities: [parseInt(candidates.length)],
      selected_items: [publicBulkData?.[0]?.PRODUCTS_ID],
      selected_tariffs: [10000],
      assessmentCode: "02",
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // If the request completes successfully, clear the timeout
      clearTimeout(timeoutId);
      // console.log(res)
      if (res?.status === 200) {
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.bill_number);

        const billdata = {
          // schoolId: '',
          billNumber: res?.data?.data?.bill_number,
          // payerId: details?.payerId,
          payerId: payerID,
          amountGenerated: totalFee,
          customerName: `${user.lastName} ${user.firstName}`,
          quantity: candidates.length,
          assessmentCode: "02",
          payerInfos: candidateInfo,
        };

        saveGeneratedBill(billdata);
        // console.log(bill);

        // console.log(bill);
        // transactionDetails.billNumber = res?.data?.data?.responseData;
        // console.log(transactionDetails);
        const modelUserTransactionDetails = {
          payerName: ` ${user.lastName} ${user.firstName} `,
          productQuantity: parseInt(candidates.length),
          price: totalFee,
          // schoolName: "",
          unitPrice: parseInt(priceInt),
          examType,
          paymentExamType: examType,
          fullDesc: "Public Service Examination",
          billNumber: res?.data?.data?.bill_number,
          payerId: user?.payerId,
          address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        // console.log(modelUserTransactionDetails);

        // console.log("i got here");
        dispatch(setTransactionDetails(modelUserTransactionDetails));
        // dispatch(setTransactionDetails(userTransactionDetails));
        dispatch(closeModal({ content: <></> }));
        navigate("/invoice");

        // console.log(modelUserTransactionDetails);
        // console.log(details);

        // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
        // console.log(details)
        // navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
      // If the request completes successfully, clear the timeout
      clearTimeout(timeoutId);
            if (axios.isAxiosError(error)) {
          const backendMessage = error.response?.data?.message || "Something went wrong";
          toast.error(backendMessage);
        } else {
           toast.error("Unable to generate invoice, please try again later.");
        }

      // console.log(error);
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);
    try {
      // e.preventDefault();
      const isEmpty = candidates.some((candidate) => {

        if (
          candidate.firstName.trim().length < 3 ||
          candidate.lastName.trim().length < 3
        ) {
          throw new Error(
            "First Name and Last Name are required with a minimum of 3 characters."
          );
        }

        if (!candidate.lga) {
          throw new Error("PSE type is required.");
          // throw new Error("Local Government Area is required.");
        }

        return false;
      });

      if (isEmpty) {
        // No need to throw an error here since all validations are handled within the `isEmpty` check
      }

      await generateBillNo();
      // console.log(transactionDetails)
      // console.log(examName)
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
    } finally {
      setInvoiceLoading(false);
    }
  };

  useEffect(() => {
    getPublicExam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        padding: "16px",
        maxHeight: "calc(100vh - 160px)",
        overflowY: "auto",
      }}
    >
      {candidates.map((candidate, index) => (
        // return (
        <div
          key={index}
          style={{
            // display: "flex",
            // alignItems: "center",
            // gap: "1.5rem",
            padding: "16px",
          }}
        >
          {showTimeoutModal && (
            <Modal
              show={showTimeoutModal}
              onHide={() => setShowTimeoutModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Server Delay</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                The bill generation is taking longer than expected. This may be
                due to a delay from our third-party server. Please wait a moment
                and try again later.
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowTimeoutModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "20px",
              // padding: "1rem",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <InputField
                  name="lastName"
                  label="Surname"
                  type="text"
                  placeholder="Enter Last Name"
                  value={candidate.lastName}
                  onChange={(e) =>
                    handleCandidateChange(
                      index,
                      "lastName",
                      e.target.value.trim()
                    )
                  }
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <InputField
                  name="FirstName"
                  label="First Name"
                  value={candidate.firstName}
                  placeholder=" Enter First Name"
                  type="text"
                  onChange={(e) =>
                    handleCandidateChange(
                      index,
                      "firstName",
                      e.target.value.trim()
                    )
                  }
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "32px" }}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <InputField
                  name="MiddleName"
                  label="Other Name"
                  value={candidate.middleName}
                  placeholder=" Enter Middle Name"
                  type="text"
                  onChange={(e) =>
                    handleCandidateChange(
                      index,
                      "middleName",
                      e.target.value.trim()
                    )
                  }
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#9b9494",
                    fontSize: "1rem",
                    fontWeight: "bolder",
                    paddingTop: "16px",
                  }}
                >
                  P.S.E
                </Typography>
                <TextField
                  label="Select Type"
                  select
                  value={candidate.lga}
                  onChange={(e) =>
                    handleCandidateChange(index, "lga", e.target.value)
                  }
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {LgaForPublic.map((lgaItem) => (
                    <MenuItem key={lgaItem.ledId} value={lgaItem.ledId}>
                      {lgaItem.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            {/* <Grid item xs={2} style={{ paddingBottom: "1rem" }}>
              <FormButton
                width="small"
                label="Add Candidate"
                onClick={addCandidate}
              />
            </Grid> */}
          </div>
          {/* visibility: candidates.length > 1 ? 'visible' : 'hidden'  */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // gap: "50%",
              visibility: candidates.length > 1 ? "visible" : "hidden",
            }}
          >
            <FormButton
              width="medium"
              label="Remove"
              onClick={() => removeCandidate(index)}
            />
          </div>
        </div>
      ))}
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputField
              name="NoOfCandidates"
              label="No of Candidates"
              type="text"
              placeholder="Enter Last Name"
              value={candidates.length}
              // onChange={(e) =>
              //   handleCandidateChange(index, "lastName", e.target.value)
              // }
              style={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={6}>
            <InputField
              name="TotalPrice"
              label="Total Price"
              value={priceInt * candidates.length}
              // placeholder=" Enter Middle Name"
              type="text"
              // onChange={(e) =>
              //   handleCandidateChange(index, "middleName", e.target.value)
              // }
              style={{ width: "100%" }}
            />
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          padding: "16px",
        }}
      >
        {/* <Button
          onClick={addTestDetail}
          color="secondary"
          variant="contained"
          sx={{
            textTransform: "inherit",
            fontWeight: "bold",
            mr: "5px",
            mt: "2rem",
          }}
        >
          Add
        </Button> */}
        {/* <Stack > */}

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
          container
        >
          <Grid item xs={2}>
            <FormButton
              width="medium"
              label="Add Candidate"
              onClick={addCandidate}
            />
          </Grid>
          <Grid item xs={2}>
           <InvoiceButtonWithConfirmation
  invoiceLoading={invoiceLoading}
  handleInvoiceClick={handleInvoiceClick}
/>

          </Grid>
        </div>
      </div>
    </div>
  );
};

export default BulkPublic;
